import { dispatchAnalyticsEvent } from "@configs/analytics/dispatch";
import { EVENTS, FIRST_DEPOSIT_SESSION_KEY } from "@configs/analytics/events/constants";
import { clearOncePerSession, resetRegistrationFormFocusOncePerSession } from "@configs/analytics/events/dedupe";
import { identifyUser, resetAnalyticsUser, setAnonymousAnalyticsContext } from "@configs/analytics/identify";
import { PayloadAction } from "@reduxjs/toolkit";
import preferenceSlice from "@stores/preference/slices";
import logger from "@utils/logger";
import { InfoResponse, ProfileResponse, SelfEntityModel } from "kz-ui-sdk";
import { call, select, takeEvery } from "redux-saga/effects";
import { RootState } from "../index";
import { AuthSliceState, authSlice } from "./slices";

async function updateAnalyticsUser(self: SelfEntityModel | null | undefined, serverPrefix?: string) {
  if (!self?.member) return;
  await identifyUser({ member: self.member, serverPrefix });
}

function* handleProfileUpdate(_action: PayloadAction<ProfileResponse | null>): Generator<any, void, any> {
  try {
    const authState: AuthSliceState = yield select((state: RootState) => state.auth);
    const { serverInfo } = yield select((state: RootState) => state.preferences);
    yield call(updateAnalyticsUser, authState.self, serverInfo?.prefix);
  } catch (error) {
    logger._console.error("Error updating analytics user properties:", error);
  }
}

function* handleInitAuthState(_action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const authState: AuthSliceState = yield select((state: RootState) => state.auth);
    const { serverInfo } = yield select((state: RootState) => state.preferences);
    yield call(updateAnalyticsUser, authState.self, serverInfo?.prefix);
  } catch (error) {
    logger._console.error("Error updating analytics user properties:", error);
  }
}

function* handleServerInfo(action: PayloadAction<InfoResponse>): Generator<any, void, any> {
  try {
    yield call(setAnonymousAnalyticsContext, { gamePrefix: action.payload.prefix });
  } catch (error) {
    logger._console.warn("Error applying anonymous analytics context:", error);
  }
}

function* handleLogout(_action: PayloadAction<void>): Generator<any, void, any> {
  try {
    dispatchAnalyticsEvent(EVENTS.LOGOUT);
    yield call(resetAnalyticsUser);

    // Clear once-per-session flags
    yield call(resetRegistrationFormFocusOncePerSession);
    yield call(clearOncePerSession, FIRST_DEPOSIT_SESSION_KEY);
  } catch (error) {
    logger._console.error("Error resetting analytics user context on logout:", error);
  }
}

export function* analyticsSaga() {
  yield takeEvery(authSlice.actions.updateProfile.type, handleProfileUpdate);
  yield takeEvery(authSlice.actions.initAuthState.type, handleInitAuthState);
  yield takeEvery(authSlice.actions.logout.type, handleLogout);
  yield takeEvery(preferenceSlice.actions.setServerInfo.type, handleServerInfo);
}
